export const SITE = {
  name: "Dr. Dixit",
  logoName: "Dr Dixit, Varanasi",
  brandLine: "DM (Gastro) IMS BHU",
  title: "Dr. Dixit — Gastroenterologist & Liver Specialist in Varanasi",
  phoneDisplay: "+91 93696 98080",
  phoneHref: "tel:+919369698080",
  hours: "Mon–Sun, 9:00 AM – 5:00 PM",
  address:
    "B 31/18-A-D-3, Rashmi Nagar Colony, behind V2 Mall, Saket Nagar Colony, Lanka, Varanasi, Uttar Pradesh – 221005",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=B+31%2F18-A-D-3%2C+Rashmi+Nagar+Colony%2C+behind+V2+Mall%2C+Lanka%2C+Varanasi%2C+Uttar+Pradesh+221005",
  areas: "Lanka · Sunderpur · BHU · Varanasi",
  domain: "https://drdixitbhugastro.in",
};
